export default __webpack_public_path__ + "static/piercing-story-1-a9b5dfc9c3f37afb7aaf690362e25475.jpg";